


import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Grid,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Theme,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import Menus, { OpenMenuItem } from '../components/views/menuItem';
import { getAllCatalogsAction, getArticlesById, getCatlogsAction, getFilterAction, getLanguageAction, usePorducts } from '@ivymobi/orbit-core/business/productCenter';
import { filter, union } from 'lodash';
import { DeviceType, WebSiteContext, InnerUserContext } from '../orbit-context';
import ZTree from './component/zTree';
import './products.css'
import RobotSearch from './component/robotSearch';
import ProductItem from './component/productItem';
import { Favorite, Share } from '@mui/icons-material';
import FilterView from './component/filterView';
import Loader from '../components/loaders';
import { Loading } from '../components';
import { getOutCatlogsAction, useOutProducts } from '@ivymobi/orbit-core/business/user';
import _ from 'lodash';
import RichText from '../components/richText/RichTextRenderer';
import { getTitle, getTitleById } from './mapping';
import PopZtree from './component/popZtree';
import wx from 'weixin-js-sdk'
import fullTexts from './fullTexts';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%'
  },
  sliderBar: {
    display: 'flex',
    flexDirection: 'column',
    width: '25%',

    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  content: {
    overflow: 'auto',
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    // justifyContent:'center',
    alignItems: 'center',
    flexDirection: 'column',
    "@media (min-width: 768px)": {
      paddingTop: theme.spacing(2),
    },
    "@media (max-width: 768px)": {
      marginTop: theme.spacing(1),
    },
    paddingBottom: theme.spacing(2)
  },


}));
const queryParse = (query) => {
  query = query.substring(query.indexOf('?') + 1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0, item.indexOf('='));
    let value = decodeURIComponent(item.substring(item.indexOf('=') + 1));
    params[key] = value;
  });
  return params;
}
export const RobotProductsView = (props) => {
  const { id, extra } = useParams<any>() ?? { id: null };
  let params = queryParse(location.search);
  const deviceType = useContext(DeviceType);
  // let prefix = getTitleById(params.catalogType);
  // if(params.catalogType==='机器人'){
  //   prefix='robot'
  // }else if(params.catalogType==='伺服'){
  //   prefix='sv'
  // }else if(params.catalogType==='变频器'){
  //   prefix='inv'
  // }
  const innerUser = useContext(InnerUserContext);
  const classes = useStyles();
  const history = useHistory();
  const { webInfo, language } = useContext(WebSiteContext);
  const [showData, setShowData] = useState(null)
  const [selectInfo, setSelectInfo] = useState({ show: false, item: null, target: null });
  const [[anchorEl, selectId], setAnchorEl] = useState([null, null]);

  const [curCatalog, setCurCatalog] = useState(null);

  const [loading, setLoading] = useState(false)
  const [curLanguage, setCurLanguage] = useState(null);

  const [mFilter, setMFilter] = useState(null);
  const [customFilter, setCustomFilter] = useState('');
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [searchResult, setSearchResult] = useState([]);

  // const [id, setId] = useState(null);
  const [result, setResult] = useState({ result: [], onRefresh: false });
  const _productState = useOutProducts();
  const [extraBreadcrumbs, setExtraBreadcrumbs] = useState([]);
  //查询文档路径 
  const [richText, setRichText] = useState(null)
  useEffect(() => {
    let selectText = null;
    for (let i = 0; i < fullTexts.length; i++) {
      if (fullTexts[i].name === curCatalog?.cgName?.zh) {
        selectText = fullTexts[i];
      }
    }
    if (selectText == null) {
      setRichText(null);
      return;

    }

    dispatch(getArticlesById({ user: { token: null, user: null }, tenant: { id: webInfo.tnt_id }, id: selectText.id })).then((res) => {
      console.log("======res===", res.data[0])
      setRichText(res.data[0]);
    })
  }, [curCatalog])
  useEffect(() => {
    let parents = [];
    let last = null;
    for (let i = 0; i < extraBreadcrumbs.length; i++) {
      if (i == (extraBreadcrumbs.length - 1)) {
        last = extraBreadcrumbs[i];
      } else
        parents.push(extraBreadcrumbs[i])
    }
    props.setTitle(last?.name)
    console.log("extraBreadcrumbs===", parents, last)
    props.setParents(parents)
  }, [extraBreadcrumbs])
  function findPath(id, paths) {
    const curCat = _productState[id];
    if (!curCat || !curCat.parentId)
      return;
    _productState[curCat.parentId].products?.map((item) => {
      if (item.id === id) {
        const breaks = { id };
        breaks.name = item.cgName?.zh;
        breaks.csname = item.csName;
        paths.push(breaks);
        findPath(curCat.parentId, paths);
      }
    });
  }

  const RequestAllCatalogs = () => {

    dispatch(getAllCatalogsAction({ id: webInfo.tnt_id, catalogType: getTitleById(params.catalogType) })).then((allCatalogs) => {
      const _allcats = filter(allCatalogs, (item) => {
        if (item.csIndex === '0')
          return false;
        return true;
      });
      setShowData(_allcats);

    });
  };
  //根据字符串搜索内容
  const RequestData = () => {
    if (!webInfo)
      return;
    setLoading(true)
    dispatch(getOutCatlogsAction({ tenantId: webInfo.tnt_id, id, nameFilter: searchText, catalogType: getTitleById(params.catalogType), shorturl: customFilter && customFilter.length > 0 ? encodeURI(customFilter) : null })).then(
      (allProductsInfos) => {
        setCurCatalog(allProductsInfos)
        setCurLanguage(language[allProductsInfos.csName])
        const _allcats = filter(allProductsInfos.catalogs, (item) => {
          if (item.csIndex === '0')
            return false;
          return true;
        });
        _allcats.map(item => {
          item.type = 'catalog';
        });
        if (allProductsInfos.productsData) {
          allProductsInfos.productsData.map(item => {
            item.type = 'product';
          });
        }
        setResult({ result: union(_allcats, allProductsInfos.productsData), onRefresh: true });
        setLoading(false)
      }, (e) => {
      }
    );
  };
  const SearchProduct = () => {
    dispatch(getOutCatlogsAction({ tenantId: webInfo.tnt_id, id, nameFilter: searchText, catalogType: getTitleById(params.catalogType), shorturl: customFilter && customFilter.length > 0 ? encodeURI(customFilter) : null })).then(
      (allProductsInfos) => {
        setCurCatalog(allProductsInfos)
        setCurLanguage(language[allProductsInfos.csName])
        const _allcats = filter(allProductsInfos.catalogs, (item) => {
          if (item.csIndex === '0')
            return false;
          return true;
        });
        _allcats.map(item => {
          item.type = 'catalog';
        });
        if (allProductsInfos.productsData) {
          allProductsInfos.productsData.map(item => {
            item.type = 'product';
          });
        }
        setSearchResult(union(_allcats, allProductsInfos.productsData));
        setLoading(false)
      }, (e) => {
      }
    );
  }
  const getExistFilter = (pre, filter) => {
    if (!pre)
      return;
    for (let m = 0; m < filter.length; m++) {
      let fOption = filter[m];
      for (let preM = 0; preM < pre.length; preM++) {
        let preOption = pre[preM];
        //大类相同 IF0000
        if (fOption[0] === preOption[0]) {
          console.log("IF0000==", fOption[0])
          for (let i = 0; i < fOption[1].length; i++) {
            let item = fOption[1][i];
            for (let preI = 0; preI < preOption[1].length; preI++) {
              let preItem = preOption[1][preI];
              console.log("item== 1==preItem", item, preItem)

              if (item[0] === preItem[0]) {
                item[2] = preItem[2];
                item[3] = preItem[3];
                item[4] = preItem[4];
                item[5] = preItem[5];
                item[6] = preItem[6];
                item[7] = preItem[7];

              }
            }
          }
        }
      }
    }
  }
  const RequestFilter = () => {
    if (!id)
      return;
    dispatch(getFilterAction({ user: { token: null, user: null }, tenant: { id: webInfo.tnt_id }, id, shorturl: customFilter && customFilter.length > 0 ? encodeURI(customFilter) : null })).then((_filter) => {
      let ops = [];
      for (let i = 0; i < _filter.options.length; i++) {
        if (_filter.options[i][0] === 'IF000003' || _filter.options[i][0] === 'IF000004' || _filter.options[i][0] === 'IF000005' || _filter.options[i][0] === 'IF000006' || _filter.options[i][0] === 'IF000007') {
          ops.push(_filter.options[i])
        }
      }
      let resu = _.sortBy(ops, function (item) {
        return item[0]
      })
      getExistFilter(mFilter, resu)


      setMFilter(resu);
      // console.log("pr11e====",pre,filter)
    });
  };
  useEffect(() => {
    if (!webInfo)
      return;

    RequestAllCatalogs();
  }, [webInfo, params.catalogType])
  useEffect(() => {
    if (!webInfo)
      return;
    RequestFilter()
    setCustomFilter('')
  }, [webInfo, id])
  useEffect(() => {
    if (!webInfo || !language)
      return;

    RequestData();

  }, [id, searchText, webInfo, language, customFilter]);
  useEffect(() => {
    if (!webInfo || !language) return;
    SearchProduct()
  }, [searchText])
  useEffect(() => {
    if (!webInfo || !language)
      return;
    RequestFilter()

  }, [id, webInfo, language, customFilter]);
  useEffect(() => {
    const paths = [];
    findPath(id, paths);
    if (deviceType === 'mobile') {
      paths.push({ to: '/' + params.catalogType + '/product?catalogType=' + params.catalogType, name: '产品中心' })
      paths.push({ to: '/' + params.catalogType, name: (getTitleById(params.catalogType) + (getTitleById(params.catalogType) === '伺服' ? '系统' : "")) ?? '' })

      // to={'/'+params.catalogType+'/product?catalogType='+params.catalogType}

    }

    paths.reverse();
    if (extra)
      paths.push({ name: '系列介绍' })
    setExtraBreadcrumbs(paths);
  }, [_productState, id, extra, deviceType]);
  const handleMenuClose = () => {
    setAnchorEl([null, null]);
  };
  useEffect(() => {
    if (selectInfo.target == null)
      return;
    setAnchorEl([selectInfo.target, selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : selectInfo.item.details.supplierAltPid]);
  }, [selectInfo]);
  if (!webInfo || !language)
    return (<Loader />)

  return (
    <div style={{ height: deviceType === 'computer' ? 'calc(100% - 30px)' : '100%' }}>
      <Menu anchorEl={anchorEl} keepMounted
        open={Boolean(anchorEl)} onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          setAnchorEl([null, null]);
          if (window.WeixinJSBridge) {
            wx.miniProgram.navigateTo({
              url: `/pages/documents/documentShare?id=${selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : (selectInfo.item.type === 'product' ? selectInfo.item.details.supplierAltPid : selectInfo.item.id)}`
            });
            return;
          }

          if (window.self === window.top) {
            props.OpenUrl('https://lite.yangbentong.com')
          } else {
            console.log("window.parent====",window.parent)
            window.parent.postMessage({ type: 'share', item: selectInfo.item },'*');

          }
        }} dense>
          <ListItemIcon>
            <Share fontSize='small' />
          </ListItemIcon>
          <Typography>分享</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          setAnchorEl([null, null]);
          if (window.WeixinJSBridge) {
            wx.miniProgram.navigateTo({
              url: `/pages/favorites/addToFavorites?did=${selectInfo.item.type === 'catalog' ? selectInfo.item.cgId : (selectInfo.item.type === 'product' ? selectInfo.item.details.supplierAltPid : selectInfo.item.id)}&type=product`,
            });
            return;
          }
          if (window.self === window.top)
            props.OpenUrl('https://lite.yangbentong.com')
          else {
            console.log('=======223=============rr', window.parent.postMessage, selectInfo.item)

            window.parent.postMessage({ type: 'collection', item: selectInfo.item }, '*');

          }
        }} >
          <ListItemIcon>
            <Favorite fontSize='small' />
          </ListItemIcon>
          <Typography>收藏</Typography>
        </MenuItem>
      </Menu>

      {deviceType === 'computer' && <Breadcrumbs style={{ height: '30px' }} separator=">" maxItems={8}>
        <Link
          //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
          //   key={b.id}
          color='textPrimary'
          to={'/' + params.catalogType}
          component={RouteLink}
        >
          {getTitle(params.catalogType) ?? ''}
        </Link>
        <Link
          //   key={b.id}
          color='textPrimary'
          to={'/' + params.catalogType + '/product?catalogType=' + params.catalogType}
          component={RouteLink}
        >
          产品中心
        </Link>
        {extraBreadcrumbs.map(item => {
          return (<Link
            //   key={b.id}
            color='textPrimary'
            to={item.id ? '/' + params.catalogType + '/product/' + item.id + '?catalogType=' + params.catalogType : null}
            component={RouteLink}
          >
            {item.name}
          </Link>)
        })}
        {/* <Typography color="textPrimary">
          
        </Typography> */}
      </Breadcrumbs>}

      {!extra && <Box className={classes.pages}>
        {deviceType === 'computer' && <Box className={classes.sliderBar}>
          <Title name={(getTitle(params.catalogType)) ?? ''}></Title>
          <Box style={{ width: '100%', height: '3px', background: 'red', marginTop: '20px' }}></Box>
          <OpenMenuItem name={'产品中心'} onClick={() => {
          }}></OpenMenuItem>
          <RobotSearch doSearch={(value) => { setSearchText(value) }}></RobotSearch>
          <ZTree curCatalog={curCatalog} setCurCatalog={setCurCatalog} data={showData} prefix={params.catalogType} catalogType={params.catalogType}></ZTree>
        </Box>}

        <Box className={classes.content}>

          {!id && <Box className='box'>
            <img className='mimg' src={`/images/banner${params.catalogType}.png`} />

          </Box>}
          {id && deviceType === 'computer' && <Box style={{ width: '90%', marginBottom: '10px' }}>
            <FilterView richText={richText} OnExtra={() => {
              console.log("curCatalog==", curCatalog)
              history.push(`/${params.catalogType}/product/${curCatalog.id}/info/?catalogType=${params.catalogType}`)
            }} id={id} curCatalog={curCatalog} setCustomFilter={setCustomFilter} language={curLanguage} filter={mFilter}></FilterView>

          </Box>}

          <Box className='products' style={{ position: 'relative' }}>

            {deviceType === 'mobile' && <PopZtree setSearchText={setSearchText} curCatalog={curCatalog} setCurCatalog={setCurCatalog} data={showData} prefix={params.catalogType} catalogType={params.catalogType}></PopZtree>}
            <Box style={{ width: '100%', height: '100%' }}>
              <Grid container spacing={deviceType === 'computer' ? 2 : 1}>
                {result.result.map((item, index) => (
                  <Grid key={`prokey_${index}`} item xs={deviceType === 'computer' ? 3 : 6} sm={deviceType === 'computer' ? 3 : 6} md={deviceType === 'computer' ? 3 : 6}>
                    <ProductItem itype={innerUser?.type} onClick={(_id) => {
                      // setId(_id)
                      if (item.type === "catalog")
                        history.push(`/${params.catalogType}/product/${_id}?catalogType=${params.catalogType}`)
                      else if (item.type === 'product') {
                        history.push(`/${params.catalogType}/productDetail/${_id}?catalogType=${params.catalogType}`)

                      }
                    }} setSelectInfo={setSelectInfo} item={item}></ProductItem>
                  </Grid>
                ))}
              </Grid>
            </Box>

          </Box>
          {loading && <Loading />}
        </Box>
      </Box>}

      {extra && <Box className={classes.pages} style={{ display: 'flex', justifyContent: 'center' }}>

        <Box style={{ width: '80%', background: "white", padding: '20px', overflow: 'auto' }}>
          <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: richText?.info }}></div>

          </Box>

        </Box>
      </Box>}
    </div>
  );
};

export default function RobotProductsContainer({ OpenUrl, setParents, setTitle }) {
  const dispatch = useDispatch();


  return (
    <RobotProductsView
      OpenUrl={OpenUrl} setParents={setParents} setTitle={setTitle}
    />
  );
}